<footer class="page-footer" [style.background-color]="backgroundColor" [style.color]="textColor">
  <div class="container">
    <div class="footer-content">
      <div class="copyright">©{{ currentYear }} {{ copyrightText }}</div>
      <app-social-icons
        [instagramUrl]="instagramUrl"
        [facebookUrl]="facebookUrl"
        [xUrl]="xUrl"
        [linkedinUrl]="linkedinUrl"
        size="medium"
        variant="default"
      >
      </app-social-icons>
    </div>
  </div>
</footer>
